import React from 'react';
export function ShieldLogo({
  className = 'w-32 h-32'
}: {
  className?: string;
}) {
  return <img src="https://cdn.magicpatterns.com/uploads/qJ6CCRPVgzUbKsCoqYVTzn/valley-grooming-logo.jpg" alt="The Valley Mobile Grooming shield logo" className={`${className} object-contain`} data-id="element-217" />;
}